const LOGIN_BANNER = "LoginBanner";
const HOME_PAGE_BANNER = "HomePageBanner";

const ALLOWED_IMAGE_NAMES = [LOGIN_BANNER, HOME_PAGE_BANNER]

export default {
    LOGIN_BANNER, 
    HOME_PAGE_BANNER, 
    ALLOWED_IMAGE_NAMES
}